module.exports = __webpack_public_path__ + "static/media/arrow-back.7e283c8c.svg";